import { Box, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { ProductType } from "../../all-types";
import { useProductSearch } from "../../hooks";
import { setSelectedTable } from "../../redux-store";
import { useAppDispatch, useAppSelector } from "../../redux-store/hooks";
import { getTableById } from "../../services";
import { BillProcessDrawer, CartItemsSummary } from "../billing/modules";
import { CategoryPanel } from "../billing/panels";
import { PaymentMode } from "../payment-mode";
import { ProductsCart } from "./product-cart-amounts";
import { ProductsCartItems } from "./product-cart-items";
import { ProductsPanel } from "./products-panel";
import { PANEL_HEIGHTS, productViewerStyles } from "./products-viewer-styles";

export const ProductsViewer = () => {
  const theme = useTheme();
  const [isCartPanelOpen, setIsCartPanelOpen] = useState(true);
  const [selectedProduct, setSelectedProduct] = useState<ProductType | null>(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const allproducts = useAppSelector(state => state.allproducts.data);
  const [editIndex, setEditIndex] = useState<number | null>(null);
  const [showBillScreen, setShowBillScreen] = useState(false);
  const selectedTable = useAppSelector(state => state.table.selectedTable);
  const createdBill = useAppSelector(state => state.table.createdBill);
  const filteredProducts = useAppSelector(state => state.allproducts?.filteredProducts) || [];
  const dispatcher = useAppDispatch();


  useEffect(() => {
    refreshTableData();
  }, []);

  const refreshTableData = async () => {
    try {
      await dispatcher(getTableById(selectedTable?._id || ""));
    } catch (e) {
      console.error(e);
    }
  }

  const handleOpenPopUp = (p: ProductType) => {
    try {
      setSelectedProduct(p);
      setIsPopupOpen(true);
    } catch (e) {
      console.error(e);
    }
  };

  const handleClosePopUp = () => {
    setIsPopupOpen(false);
    setEditIndex(null);
  };

  const handleEditCartItem = (productId: string, editIndex: number) => {
    try {
      const product = allproducts.find(p => p.productId === productId);
      if (product) {
        setEditIndex(editIndex);
        handleOpenPopUp(product);
      }
    } catch (e) {
      console.error(e);
    }
  }



  const clearBillAndCloseTable = async () => {
    await dispatcher(setSelectedTable(null));
  }



  const { setCategoryTxt, categories } = useProductSearch();

  if (createdBill !== null) {
    return (
      <Box sx={productViewerStyles.summaryPanel(theme, isCartPanelOpen, PANEL_HEIGHTS)}>
        <BillProcessDrawer isLoading={false} open={createdBill !== null} handleRemoveTab={clearBillAndCloseTable} />
      </Box>
    )
  }

  return (
    <Box sx={productViewerStyles.billingScreen(theme, PANEL_HEIGHTS)}>

      {showBillScreen ? (
        <>
          {/* LEF PANEL */}
          <Box sx={productViewerStyles.summaryPanel(theme, isCartPanelOpen, PANEL_HEIGHTS)}>
            <CartItemsSummary currentTab={"TEMPTAB123"} cartItems={selectedTable?.billSession?.items || []} />
          </Box>
          {/* RIGHT PANEL */}
          <Box sx={productViewerStyles.rightPanel(theme, isCartPanelOpen, PANEL_HEIGHTS)}>
            <PaymentMode />
            <ProductsCart freeTheTable={() => console.log("free the table")} goBack={() => setShowBillScreen(false)} isSummary={true} showBillingScreen={() => setShowBillScreen(true)} />
          </Box>
        </>
      ) : (
        <>
          {/* LEFT PANEL */}
          <Box sx={productViewerStyles.categoryPanel(theme, PANEL_HEIGHTS)}>
            <CategoryPanel setCategoryTxt={setCategoryTxt} categories={categories} />
          </Box>

          <Box sx={productViewerStyles.productPanel(theme, true, PANEL_HEIGHTS)}>
            <ProductsPanel products={filteredProducts} currentTab={"T8"}
              selectedProduct={selectedProduct} isPopupOpen={isPopupOpen}
              openPopUp={handleOpenPopUp} closePopUp={handleClosePopUp}
              editIndex={editIndex} />
          </Box>

          {/* RIGHT PANEL */}
          <Box sx={productViewerStyles.rightPanel(theme, isCartPanelOpen, PANEL_HEIGHTS)}>
            <ProductsCartItems handleItemEdit={handleEditCartItem} />
            <ProductsCart freeTheTable={() => console.log("free the tabvle")} isSummary={false} showBillingScreen={() => setShowBillScreen(true)} />
          </Box>
        </>

      )}
    </Box>
  )
}